import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import Logo from './Logo';
import NavbarToggleButton from './NavbarToggleButton';
import Navigation from './Navigation';

interface Props {
  className?: string;
  opened: boolean;
}

const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  justifyContent: 'space-between',
  color: theme.palette.text.primary,
  '& ::-webkit-scrollbar-thumb': {
    boxShadow: 'inset 0 0 0 20px rgba(0, 0, 0, 0.37)',
  },
  '& ::-webkit-scrollbar-thumb:active': {
    boxShadow: 'inset 0 0 0 20px rgba(156, 150, 150, 0.37)',
  },
  '& .navbar-footer': {
    position: 'sticky',
    bottom: 0,
    zIndex: 5,
    backgroundColor: theme.palette.background.default,
    paddingTop: 12,
    paddingBottom: 12,
    // Aislar el footer para evitar reflows en algunos navegadores
    contain: 'layout paint',
  },
}));

const NavbarStyleContent = (props: Props) => {
  return (
    <Root
      className={clsx(
        'flex flex-auto flex-col overflow-hidden h-full',
        props.className
      )}
    >
      <div className='h-full flex flex-col'>
        <div className='flex-1 min-h-0 overflow-auto'>
          <div className="flex flex-row items-center shrink-0 h-48 md:h-76 px-12 NavbarStyle-header">
            <div className="flex flex-1">
              <Logo />
            </div>

            <NavbarToggleButton className="w-40 h-40 p-0 toggle-button" />
          </div>

          <div className="flex flex-col justify-between min-h-0">
            <Navigation />
          </div>
        </div>

        <div className="navbar-footer flex flex-col items-center">
          {props.opened && <div className="cmfLabel">Registrados y Regulados por</div>}
          <img
            className={clsx("cmfLogo", { 'h-48': props.opened, 'h-18': !props.opened })}
            src={`${process.env.PUBLIC_URL}/assets/images/${!props.opened ? 'logo-CMF.png': 'logo-CMF-full.png'}`}
            alt="logo cmf"
          />
        </div>
      </div>
    </Root>
  );
};

export default NavbarStyleContent;
